<script>
import PackingManifest from "@/components/order/PackingManifest.vue";

export default {
  components: { PackingManifest },
  data() {
    return {
      orderNumber: this.$route.params?.orderNumber
    };
  }
};
</script>

<template>
  <PackingManifest :orderNumber="orderNumber" />
</template>
